var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { getType } from "typesafe-actions";
import * as peerReviews from "./actions";
export var initialState = {
  options: [],
  answer: null,
  submitDisabled: true
};
export var peerReviewsReducer = function peerReviewsReducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case getType(peerReviews.set):
      return action.payload;

    case getType(peerReviews.setReviewAnswer):
      return __assign({}, state, {
        answer: action.payload
      });

    case getType(peerReviews.setReviewOptions):
      return __assign({}, state, {
        options: action.payload
      });

    case getType(peerReviews.clear):
      return initialState;

    case getType(peerReviews.changeGradeAction):
      {
        var _a = action.payload,
            peerReviewQuestionId_1 = _a.peerReviewQuestionId,
            value_1 = _a.value,
            peerReviewCollection = _a.peerReviewCollection;
        var currentAnswer = state.answer;

        if (!currentAnswer) {
          console.log("peer review answer is null");
          return state;
        }

        var newAnswer = __assign({}, currentAnswer, {
          answers: currentAnswer.answers.map(function (answer) {
            return answer.peerReviewQuestionId === peerReviewQuestionId_1 ? __assign({}, answer, {
              value: value_1
            }) : answer;
          })
        });

        var submitDisabled = submitShouldBeDisabled(newAnswer, peerReviewCollection);
        return __assign({}, state, {
          answer: newAnswer,
          submitDisabled: submitDisabled
        });
      }

    case getType(peerReviews.changeTextAction):
      {
        var _b = action.payload,
            peerReviewQuestionId_2 = _b.peerReviewQuestionId,
            text_1 = _b.text,
            peerReviewCollection = _b.peerReviewCollection;
        var currentAnswer = state.answer;

        if (!currentAnswer) {
          console.log("peer review answer is null");
          return state;
        }

        var newAnswer = __assign({}, currentAnswer, {
          answers: currentAnswer.answers.map(function (answer) {
            return answer.peerReviewQuestionId === peerReviewQuestionId_2 ? __assign({}, answer, {
              text: text_1
            }) : answer;
          })
        });

        var submitDisabled = submitShouldBeDisabled(newAnswer, peerReviewCollection);
        return __assign({}, state, {
          answer: newAnswer,
          submitDisabled: submitDisabled
        });
      }

    case getType(peerReviews.selectAnswer):
      var _c = action.payload,
          quizAnswerId_1 = _c.quizAnswerId,
          userId = _c.userId,
          peerReviewCollectionId = _c.peerReviewCollectionId,
          questionIds = _c.questionIds;
      var answersToReview = state.options;
      var rejected = answersToReview.filter(function (answer) {
        return answer.id !== quizAnswerId_1;
      });
      var peerReviewAnswer = {
        quizAnswerId: quizAnswerId_1,
        userId: userId,
        peerReviewCollectionId: peerReviewCollectionId,
        rejectedQuizAnswerIds: rejected.map(function (x) {
          var id = x.id;

          if (!id) {
            console.log("Should be impossible for received quiz answer not to have id...");
            return "";
          }

          return id;
        }),
        answers: questionIds.map(function (questionId) {
          return {
            peerReviewQuestionId: questionId,
            value: null
          };
        })
      };
      return __assign({}, state, {
        answer: peerReviewAnswer
      });

    default:
      return state;
  }
};

var submitShouldBeDisabled = function submitShouldBeDisabled(prAnswer, peerReviewCollection) {
  return prAnswer.answers.some(function (answer) {
    var questionId = answer.peerReviewQuestionId;
    var peerReviewQuestion = peerReviewCollection.questions.find(function (q) {
      return q.id === questionId;
    });

    if (!peerReviewQuestion) {
      console.log("Peer review answer to question doesn't match any peer review question");
      return true;
    }

    var answerIsRequired = peerReviewQuestion.answerRequired;

    if (!answerIsRequired) {
      return false;
    }

    if (typeof answer.value === "number") {
      return false;
    }

    answer = answer;

    if (typeof answer.text !== "string") {
      return true;
    }

    return answerIsRequired && answer.text.trim().length === 0;
  });
};